import { Text } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

export interface SummaryItem {
  name: string
  value: ReactNode
}

export interface SummaryBoxesProps {
  items: SummaryItem[]
}

export const SummaryBoxesComponent = ({ items }: SummaryBoxesProps): ReactElement => (
  <Styled.SummaryBoxesWrapper>
    {items.map(({ name, value }) => (
      <Styled.SummaryBox key={name}>
        <Text colorVariant="secondary" nowrap>
          {name}
        </Text>
        <Text variant="bodyLG" weight="medium" nowrap>
          {value}
        </Text>
      </Styled.SummaryBox>
    ))}
  </Styled.SummaryBoxesWrapper>
)
